<template>
  <div class="component-form my-3">
    <v-row>
      <v-col
        cols="12"
        class="py-2 d-flex"
      >
        <h2 class="d-flex align-center">
          Component {{ ordinal + 1 }}
        </h2>
        <v-spacer />
        <v-btn
          v-if="ordinal !== 0"
          icon
          color="danger"
          @click="$emit('remove')"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="c.componentType"
          clearable
          label="Component Type"
          :items="componentTypes"
          item-text="label"
          item-value="id"
          outlined
          dense
          hide-details
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title v-html="data.item.label" />
              <v-list-item-subtitle v-html="data.item.description" />
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col
        v-if="isImgComponent"
        cols="12"
      >
        <v-card
          v-if="c.text"
          style="max-width: 200px"
        >
          <v-img
            :src="c.text"
            aspect-ratio="1"
            contain
            class="grey lighten-2"
            style="cursor: pointer"
            @click="openImageDir"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                />
              </v-row>
            </template>
          </v-img>
          <v-divider />
          <v-card-actions class="justify-end">
            <v-btn
              id="image_ok"
              raised
              text
              color="success"
              dark
              class="pl-0"
              @click="openImageDir()"
            >
              Select
              <v-icon right>
                mdi-paperclip
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card
          v-else
          style="max-width: 200px"
        >
          <v-icon
            size="200"
            color="grey lighten-1"
            @click="openImageDir"
          >
            mdi-image-plus
          </v-icon>
        </v-card>
        <span class="caption"> <strong>Note:</strong> Upload logo with dimensions 300 * 300.</span>
      </v-col>

      <v-col
        v-else
        cols="12"
      >
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="c.label"
              label="Label"
              outlined
              dense
              hide-details=""
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="c.text"
              label="Text"
              outlined
              dense
              hide-details=""
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ImageConfig
      :show-image-config.sync="showImgDir"
      @attachImg="setSelectedImg"
    />
  </div>
</template>

<script>
import { componentTypes } from "./templateHelper/Helper.js";
import ImageConfig from "./ImageConfig";

export default {
  name: "LineComponent",
  components: {
    ImageConfig
  },
  props: {
    ordinal: {
      type: Number,
      default: 0
    },
    c: {
      type: Object,
      required: true
    },
    componentTypes: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      showImgDir: false,
      baseURL: `${this.IMAGE_SERVER_API_URL}/images`
    };
  },
  computed: {
    isImgComponent() {
      return this.c.componentType === componentTypes.IMAGE;
    }
  },
  methods: {
    openImageDir() {
      this.showImgDir = true;
    },
    setSelectedImg(imgObj) {
      this.c.galleryId = imgObj.id;
      this.c.text = imgObj.url;
    },
    formatImgSrc(val) {
      if (!val) return "";

      // If it's already a full URL string (New Server way)
      if (typeof val === "string"&& val.startsWith("http")) {
        return val;
      }

      // If it's a number (Old Server way), wrap it in your API URL
      // Use the same redirect logic we discussed for the backend
      return `${this.IMAGE_SERVER_API_URL}/images/${val}`;
    }
  }
};
</script>

<style lang="scss">
.component-form {
  border: 1px dashed #e9e9e9;
  padding: 10px;
  display: flex;
}
</style>